import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, map, Observable, take } from 'rxjs';
import { Idioma } from '@core/models';
import { Store } from '@ngrx/store';
import { selectLanguageAvailable } from '@store/selectors';
import { MenuItem } from 'primeng/api';
import { transformDropdown } from '@core/helpers';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
	languageList$: Observable<MenuItem[]>;

  constructor(
		private http: HttpClient,
		private store: Store,
	) {
		this.languageList$ = this.store.select(selectLanguageAvailable);
	}

  find(language: string): Observable<Idioma> {
    return this.http.get<Idioma>(
      `/assets/i18n/${language.toLowerCase()}.json`
    );
  }

  getTranslation(key: string, translations: Idioma): string {
    return translations[key] || key;
  }

  getDropdown(): Observable<MenuItem[]> {
    return this.languageList$.pipe(
      filter((languages): languages is MenuItem[] => !!languages),
      map((languages) =>
        transformDropdown(languages, 'id', 'name')
      ),
      take(1)
    );
  }
}
